import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap';
import VCalendar from 'v-calendar';
import './assets/css/main.scss'
import Default from './layouts/Default.vue'
import NoNavbar from './layouts/NoNavbar.vue'

import {
  library
} from '@fortawesome/fontawesome-svg-core'

import {
  faCloudRain,
  faCloudShowersHeavy,
  faUserCircle,
  faLockOpen,
  faHome,
  faInbox,
  faChartBar,
  faSlidersH,
  faArrowsAlt,
  faTimes,
  faMobileAlt,
  faPaperPlane,
  faPaperclip,
  faFileInvoice,
  faCircleNotch,
  faTrashAlt,
  faVideo,
  faAngleRight,
  faMapMarkerAlt,
  faFileDownload,
  faCheck,
  faChartLine,
  faExclamationTriangle,
  faCommentAlt,
  faAngleDown,
  faUpload,
  faPlus,
  faMinus,
  faCheckCircle,
  faRoad,
  faTimesCircle,
  faHardHat,
  faFilter,
  faTruckPickup,
  faAt,
  faCircle,
  faAngleLeft,
  faTh,
  faList,
  faCar,
  faKey,
  faSearchLocation,
  faClock,
  faCheckDouble,
  faFileSignature,
  faImage,
  faComments,
  faSearch,
  faMinusCircle,
  faAngleUp,
  faSignOutAlt,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSatellite,
  faImages,
  faWater,
  faFilePdf,
  faClipboardList,
  faHelicopter,
  faClosedCaptioning,
  faUserCog,
  faExternalLinkAlt,
  faExternalLinkSquareAlt,
  faCloudSun,
  faFileInvoiceDollar,
  faFileUpload,
  faCalendarTimes,
  faCrosshairs,
  faFileExcel,
} from '@fortawesome/free-solid-svg-icons'
import {
  faCalendarAlt,
  faCommentDots,
  faEdit,
  faSquare,
  faStickyNote,
  faSun
} from '@fortawesome/free-regular-svg-icons'
import {
  faAppStoreIos,
  faFacebookSquare,
  faGooglePlay,
  faInstagram,
  faTwitter,
  faWaze
} from '@fortawesome/free-brands-svg-icons'

import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import JsonCSV from 'vue-json-csv'
import ImageLazy from 'cube-vue-image-lazy'

Vue.use(ImageLazy)

// Or you can override defaults
Vue.use(ImageLazy, {
  name: 'ImageLazyLoad',
  delay: 2500,
  baseClass: 'image-lazy-load',
  deferredClass: 'image-lazy-load-deferred',
  loadingClass: 'image-lazy-load-loading',
  loadedClass: 'image-lazy-load-loaded'
})

Vue.component('downloadCsv', JsonCSV)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('default-layout', Default)
Vue.component('no-navbar-layout', NoNavbar)

library.add(faUserCog)
library.add(faFilePdf)
library.add(faCloudShowersHeavy)
library.add(faCloudRain)
library.add(faWater)
library.add(faImages)
library.add(faSatellite)
library.add(faChevronDown)
library.add(faChevronUp)
library.add(faChevronRight)
library.add(faChevronLeft)
library.add(faSignOutAlt)
library.add(faUserCircle)
library.add(faLockOpen)
library.add(faHome)
library.add(faInbox)
library.add(faChartBar)
library.add(faFacebookSquare)
library.add(faTwitter)
library.add(faWaze)
library.add(faMobileAlt)
library.add(faSlidersH)
library.add(faArrowsAlt)
library.add(faTimes)
library.add(faPaperPlane)
library.add(faPaperclip)
library.add(faFileInvoice)
library.add(faCircleNotch)
library.add(faTrashAlt)
library.add(faVideo)
library.add(faAngleRight)
library.add(faMapMarkerAlt)
library.add(faFileDownload)
library.add(faCheck)
library.add(faChartLine)
library.add(faExclamationTriangle)
library.add(faCommentAlt)
library.add(faAngleDown)
library.add(faUpload)
library.add(faSquare)
library.add(faPlus)
library.add(faMinus)
library.add(faCheckCircle)
library.add(faTimesCircle)
library.add(faRoad)
library.add(faCalendarAlt)
library.add(faInstagram)
library.add(faHardHat)
library.add(faEdit)
library.add(faFilter)
library.add(faTruckPickup)
library.add(faAt)
library.add(faCircle)
library.add(faAngleLeft)
library.add(faTh)
library.add(faList)
library.add(faComments)
library.add(faCar)
library.add(faKey)
library.add(faSearchLocation)
library.add(faClock)
library.add(faCheckDouble)
library.add(faFileSignature)
library.add(faStickyNote)
library.add(faImage)
library.add(faCommentDots)
library.add(faSearch)
library.add(faMinusCircle)
library.add(faAngleUp)
library.add(faClipboardList)
library.add(faHelicopter)
library.add(faClosedCaptioning);
library.add(faExternalLinkAlt)
library.add(faExternalLinkSquareAlt)
library.add(faAppStoreIos)
library.add(faGooglePlay)
library.add(faSun)
library.add(faFileInvoiceDollar)
library.add(faFileUpload)
library.add(faFilePdf)
library.add(faCalendarTimes)
library.add(faCrosshairs)
library.add(faFileExcel)

Vue.use(VCalendar, {});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')